import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import {
  M08_MODULE_INFO,
  M08_TOPICS,
  getAllM08Problems
} from '../data/mathExercises/M08_QuadraticFunctionsEquations.js';

const M08QuadraticFunctionsEquationsExercise = ({ onProgress }) => {
  const topics = M08_TOPICS;
  const problems = getAllM08Problems();
  const moduleInfo = M08_MODULE_INFO;

  return (
    <ExerciseInterface
      moduleInfo={moduleInfo}
      topics={topics}
      problems={problems}
      onProgress={onProgress}
      className="m08-exercise"
    />
  );
};

export default M08QuadraticFunctionsEquationsExercise; 